import React from "react";

//components
import Icon from "../../../global/icons/Icon";
import ProfileImage from "../../images/profileImages/ProfileImage";

//helpers
import { IconLibrary } from "../../../../interfaces/icon/IconLibrary";
import { IMediaInfo } from "../../../../interfaces/information/IInformation";


const MediaInfo = ({className, profileImageUrl, displayName, mediaTitle, date}: IMediaInfo) => {

    return (
        <div className={`media-info-wrapper ${className}`} >
            <div className="left-panel">
                <ProfileImage profileImageUrl={profileImageUrl} isSquareImage/>
            </div>

            <div className="right-panel">
                <span className="user-data">
                    {displayName}
                </span>

                <span className="media-data">
                    {mediaTitle}

                    <Icon iconName={IconLibrary.MIDDOT} sizeInPx="8" className="mid-dot" color="var(--thriveLightSlate)"/>
                    
                    {date}
                </span>
            </div>
           
        </div>
    );
};

export default MediaInfo 